import { render, staticRenderFns } from "./CookingCard.vue?vue&type=template&id=533af2ac&scoped=true&"
import script from "./CookingCard.vue?vue&type=script&lang=js&"
export * from "./CookingCard.vue?vue&type=script&lang=js&"
import style0 from "./CookingCard.vue?vue&type=style&index=0&id=533af2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533af2ac",
  null
  
)

export default component.exports